import { styled } from 'baseui'
import { FlexColumn, FlexBetween, FlexCenterY } from '@/shared/theme/styled-components'

export const LayoutContainer = styled(FlexColumn, ({ $theme }) => ({
  height: '100%',
  width: '100%',
  boxSizing: 'border-box',
  backgroundColor: $theme.colors.white,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
}))

export const ContentWrapper = styled('div', {
  display: 'flex',
  width: '100%',
  boxSizing: 'border-box',
  gap: '2rem',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
})

export const LeftColumn = styled(FlexColumn, {
  flex: 1,
  gap: '1rem',
})

export const RightColumn = styled('div', {
  flex: 1,
})

export const SaleFormContainer = styled(FlexColumn, ({ $theme }) => ({
  width: '100%',
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: '100%',
  boxSizing: 'border-box',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  backgroundColor: $theme.colors.white,
}))

export const TopHeaderContainer = styled(FlexColumn, ({ $theme }) => ({
  width: '100%',
  backgroundColor: $theme.colors.white,
  marginBottom: '0.2rem',
  flexGrow: 1,
}))

export const TopHeaderBar = styled(FlexBetween, {
  padding: '0 0 0 0.6rem',
  gap: '1rem',
})

export const TopHeaderMessages = styled(FlexColumn, {
  alignItems: 'center',
  width: '100%',
  gap: '0.25rem',
  marginTop: '0.5rem',
})

export const Breadcrumb = styled(FlexCenterY, ({ $theme }) => ({
  fontSize: '14px',
  color: $theme.colors.textMuted,
  flexShrink: 0,
}))

export const BreadcrumbItem = styled('div', ({ $theme, $backgroundColor, $color }) => ({
  padding: '4px 12px',
  borderRadius: '9999px',
  fontSize: '14px',
  fontWeight: 600,
  backgroundColor: $backgroundColor || $theme.colors.bgWashAlt,
  color: $color || $theme.colors.textMedium,
}))
